<template>
  <page>
    <template slot='content'>
      <indicadores-preventiva-armazem></indicadores-preventiva-armazem>

      <Hr />

      <os-preventiva-armazem-component></os-preventiva-armazem-component>
      <reloadPage></reloadPage>
    </template>
  </page>
</template>
  
<script>
import Page from '@/components/Page'
import OsPreventivaArmazemComponent from '../components/Armazem/OsPreventivaArmazemComponent.vue'
import IndicadoresPreventivaArmazem from '../components/IndicadoresPreventivaArmazem.vue'
// import IndicadoresResumo from '@/components/IndicadoresResumo'
import reloadPage from '../common/reloadPage.vue'

export default {
  components: {
    Page,
    OsPreventivaArmazemComponent,
    IndicadoresPreventivaArmazem,
    reloadPage
  },

  beforeDestroy() {
    clearTimeout(this.timer)
  },

  created() {

  },

  data() {
    return {
      isSidebarOpen: false,
      breadcrumbItems: [
        {
          text: 'Ordens para atendimento',
          active: true
        }
      ],
      timer: ''
    }
  },
  
  methods: {

  }
}
</script>
  